<script>
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'DeleteImageBoxTool',
  extends: ImageBoxTool,
  props: {
    isEditing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: 'delete',
      title: 'Delete',
      showLocal: true,

      hotkey: 'backspace',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas.getActiveObject()) {
        this.showLocal = true;
      } else {
        this.showLocal = false;
      }
    },
    action(evt) {
      if (this.canvas.getActiveObject()) {
        if ((this.canvas.getActiveObject().isEditing || this.isEditing) && evt.type === 'keydown') {
          return;
        }
        this.canvas.remove(this.canvas.getActiveObject());
        this.$emit('closeDialog');
      }
    },
  },
};
</script>
